/** Shared runtime config filled by system store — avoids circular import with request.js */
export const systemConfig = {
  appId: '',
  appSecret: '',
  nasFileHost: '',
  authorityUrl: ''
}

export function patchSystemConfig(partial) {
  Object.assign(systemConfig, partial)
}
